export interface cv_PermitExternalPurpose {
    C_PermitExternalPurpose_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    Abbreviation: string;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    IsEndState: boolean;
    ModifiedBy: string;
    PermitExternalPurpose: string;
    SortOrder: number | null;
    Version: number;
}
